import React, { } from "react";
import { IoEyeSharp } from "react-icons/io5";
import { ContactSTableComponets } from "./ContactSTableComponets";
// import { ContactTableComponets } from "../Customer/ContactTableComponets";
// import { ContactTableComponets } from "./ContactTableComponets";


function ContactStable() {

  let header = [
    { label: "Id", field: "id" },
    { label: "contactname", field: "contactname" },
    { label: "Email", field: "email" },
    { label: "Mobile No.", field: "mobileno" },
    { "label": "Action", "field": "action","subaction1": <IoEyeSharp className="indexeye"/> }
  ];
  const sumofkeys = [{ first: "staffname" }];
  return (
    <div>
    <ContactSTableComponets
      head={header}
      title={" SUPPLIER CONTACT"}
      axiostabledata={"supplierContactPerson/page"}
    Add={"+ ADD"}
    Create={"/contactSCreate"}
    // Edit={"/contactSView"}
    View={"/contactSView"}
      Sumofkeys={sumofkeys}
    />
    </div>
  );
}

export default ContactStable;
